import {stat} from "copy-webpack-plugin/dist/utils/promisify";

const getters = {
  theme: state => state.app.theme,
  storeType: state => state.app.storeType,
  token: state => state.app.token,
  shopId: state => state.app.shopId,
  phone: state => state.app.phone,
  userName: state => state.app.userName,
  maxNum: state => state.app.maxNum,
  areadyNum: state => state.app.areadyNum,
  openId: state => state.app.openId,
  nickName: state => state.app.nickName,
  headImgUrl: state => state.app.headImgUrl,
  currentAlbum: state => state.app.currentAlbum,
  ifEnterpriseGoods: state => state.app.ifEnterpriseGoods,
  industryCode: state => state.app.industryCode,
  userCode: state => state.app.userCode,
  vipState: state => state.app.vipState,
  isDanBo: state => state.app.isDanBo,
  isHaidilao: state => state.app.isHaidilao,
  designid: state => state.app.designid,
  ogId: state => state.app.ogId,
  styleTheme: state => state.app.styleTheme,
  shopName: state => state.app.shopName,
  childShopName: state => state.app.childShopName,
  childShopCode: state => state.app.childShopCode,
  logo: state => state.app.logo,
  isZhongfu: state => state.app.isZhongfu,
  xjchshopID: state => state.app.xjchshopID,

};

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js